import React from 'react'
import { FormContextProvider } from '../../../../context/formContext'
import CreateEditForm from './CreateEditForm'
import Toast from '../../../../components/Toast/Toast'
const FormWrapper = () => {
  return (
    <FormContextProvider>
      <CreateEditForm />
      <Toast />
    </FormContextProvider>
  )
}

export default FormWrapper
